<template>
	<v-chip
		variant="outlined"
		class="badge-muted copy-id-chip"
		data-test="task-id-value"
	>
		<router-link
			:to="link"
			class="id-truncated sgnl-text-color-secondary"
			>{{ formattedTaskID }}</router-link
		>
		<CopyToClipboardButton
			v-if="showClipboardButton"
			:value-to-copy="taskID"
			value-name="Task ID"
		/>
	</v-chip>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { RouteLocationRaw } from "vue-router";
import CopyToClipboardButton from "@/components/Common/CopyToClipboardButton.vue";
import * as util from "@/js/utilities";

export default defineComponent({
	name: "TaskIDDisplay",
	components: {
		CopyToClipboardButton,
	},
	props: {
		taskID: { type: String },
		link: { type: Object as PropType<RouteLocationRaw>, required: true },
		showClipboardButton: { type: Boolean, default: false },
		// { name: 'TaskDetail', params: { id: this.projectID }}
	},
	computed: {
		formattedTaskID(): string {
			return this.taskID ? util.shortenID(this.taskID) : "";
		},
	},
});
</script>

<style scoped>
.id-truncated {
	white-space: nowrap;
	text-decoration: none;
}
</style>
